import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Streets} from './streets.model';

export const loadStreetss = createAction(
  '[Streets/API] Load Streetss',
  props<{ streetss: Streets[] }>()
);

export const addStreets = createAction(
  '[Streets/API] Add Streets',
  props<{ streets: Streets }>()
);

export const upsertStreets = createAction(
  '[Streets/API] Upsert Streets',
  props<{ streets: Streets }>()
);

export const addStreetss = createAction(
  '[Streets/API] Add Streetss',
  props<{ streetss: Streets[] }>()
);

export const upsertStreetss = createAction(
  '[Streets/API] Upsert Streetss',
  props<{ streetss: Streets[] }>()
);

export const updateStreets = createAction(
  '[Streets/API] Update Streets',
  props<{ streets: Update<Streets> }>()
);

export const updateStreetss = createAction(
  '[Streets/API] Update Streetss',
  props<{ streetss: Update<Streets>[] }>()
);

export const deleteStreets = createAction(
  '[Streets/API] Delete Streets',
  props<{ id: string }>()
);

export const deleteStreetss = createAction(
  '[Streets/API] Delete Streetss',
  props<{ ids: string[] }>()
);

export const clearStreetss = createAction(
  '[Streets/API] Clear Streetss'
);


// Custom Actions
export const getAllStreets = createAction(
  '[Regions/API] Get All Streets',
  props<{wardUniqueId: string}>()
);
